/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 7H15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4 19.5V8.4C4 6.15979 4 5.03968 4.43597 4.18404C4.81947 3.43139 5.43139 2.81947 6.18404 2.43597C7.03968 2 8.15979 2 10.4 2H13.6C15.8402 2 16.9603 2 17.816 2.43597C18.5686 2.81947 19.1805 3.43139 19.564 4.18404C20 5.03968 20 6.15979 20 8.4V17.5M20 17H6.5C5.11929 17 4 18.1193 4 19.5V19.5C4 20.8807 5.11929 22 6.5 22H15C15.9293 22 16.394 22 16.7804 21.9231C18.3671 21.6075 19.6075 20.3671 19.9231 18.7804C20 18.394 20 17.9293 20 17V17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M13.6 2H10.4C8.15979 2 7.03969 2 6.18404 2.43597C5.43139 2.81947 4.81947 3.43139 4.43597 4.18404C4 5.03969 4 6.15979 4 8.4V18L4.06274 17.9373L4.06275 17.9373C4.40865 17.5914 4.5816 17.4184 4.78343 17.2947C4.96237 17.1851 5.15746 17.1043 5.36154 17.0553C5.59171 17 5.8363 17 6.32548 17H20V8.4C20 6.15979 20 5.03969 19.564 4.18404C19.1805 3.43139 18.5686 2.81947 17.816 2.43597C16.9603 2 15.8402 2 13.6 2Z"
				fill="currentColor"
			/>
			<path
				d="M4 19.5V8.4C4 6.15979 4 5.03968 4.43597 4.18404C4.81947 3.43139 5.43139 2.81947 6.18404 2.43597C7.03968 2 8.15979 2 10.4 2H13.6C15.8402 2 16.9603 2 17.816 2.43597C18.5686 2.81947 19.1805 3.43139 19.564 4.18404C20 5.03968 20 6.15979 20 8.4V17.5M9 7H15M20 17H6.5C5.11929 17 4 18.1193 4 19.5V19.5C4 20.8807 5.11929 22 6.5 22H15C15.9293 22 16.394 22 16.7804 21.9231C18.3671 21.6075 19.6075 20.3671 19.9231 18.7804C20 18.394 20 17.9293 20 17V17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.25 7.65V19.5C3.25 21.2949 4.70507 22.75 6.5 22.75H15L15.0953 22.75H15.0953C15.9334 22.7501 16.4668 22.7502 16.9267 22.6587C18.811 22.2839 20.2839 20.811 20.6587 18.9267C20.7502 18.4668 20.7501 17.9334 20.75 17.0953L20.75 17V7.65C20.75 5.40979 20.75 4.28969 20.314 3.43404C19.9305 2.68139 19.3186 2.06947 18.566 1.68597C17.7103 1.25 16.5902 1.25 14.35 1.25H9.65C7.40979 1.25 6.28969 1.25 5.43404 1.68597C4.68139 2.06947 4.06947 2.68139 3.68597 3.43404C3.25 4.28969 3.25 5.40979 3.25 7.65ZM4.75 19.5C4.75 20.4665 5.5335 21.25 6.5 21.25H15C15.9653 21.25 16.3384 21.2464 16.634 21.1876C17.9233 20.9311 18.9311 19.9233 19.1876 18.634C19.2279 18.4312 19.2423 18.1919 19.2473 17.75H6.5C5.5335 17.75 4.75 18.5335 4.75 19.5ZM14.75 7.75C15.1642 7.75 15.5 7.41421 15.5 7C15.5 6.58579 15.1642 6.25 14.75 6.25H9.25C8.83579 6.25 8.5 6.58579 8.5 7C8.5 7.41421 8.83579 7.75 9.25 7.75H14.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M20 17V17C20 17.9293 20 18.394 19.9231 18.7804C19.6075 20.3671 18.3671 21.6075 16.7804 21.9231C16.394 22 15.9293 22 15 22H6.5C5.11929 22 4 20.8807 4 19.5V19.5C4 18.1193 5.11929 17 6.5 17H16M4 19.5V8.4C4 6.15979 4 5.03968 4.43597 4.18404C4.81947 3.43139 5.43139 2.81947 6.18404 2.43597C7.03968 2 8.15979 2 10.4 2H13.6C15.8402 2 16.9603 2 17.816 2.43597C18.5686 2.81947 19.1805 3.43139 19.564 4.18404C20 5.03968 20 6.15979 20 8.4V17.5M9 7H15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M4 19.5V8.4C4 6.15979 4 5.03968 4.43597 4.18404C4.81947 3.43139 5.43139 2.81947 6.18404 2.43597C7.03968 2 8.15979 2 10.4 2H13.6C15.8402 2 16.9603 2 17.816 2.43597C18.5686 2.81947 19.1805 3.43139 19.564 4.18404C20 5.03968 20 6.15979 20 8.4V17.5M9 7H15M20 17H6.5C5.11929 17 4 18.1193 4 19.5V19.5C4 20.8807 5.11929 22 6.5 22H15C15.9293 22 16.394 22 16.7804 21.9231C18.3671 21.6075 19.6075 20.3671 19.9231 18.7804C20 18.394 20 17.9293 20 17V17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.3"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.25 19.5V7.65C3.25 5.40979 3.25 4.28969 3.68597 3.43404C4.06947 2.68139 4.68139 2.06947 5.43404 1.68597C6.28969 1.25 7.40979 1.25 9.65 1.25H14.35C16.5902 1.25 17.7103 1.25 18.566 1.68597C19.3186 2.06947 19.9305 2.68139 20.314 3.43404C20.75 4.28969 20.75 5.40979 20.75 7.65V17H19.25H5.75C4.36929 17 3.25 18.1193 3.25 19.5Z"
				fill="currentColor"
			/>
			<path
				d="M6.5 16.25C4.70507 16.25 3.25 17.7051 3.25 19.5C3.25 21.2949 4.70507 22.75 6.5 22.75H14.9167C16.6241 22.75 17.4778 22.75 18.159 22.4936C19.2371 22.0879 20.0879 21.2371 20.4936 20.159C20.75 19.4778 20.75 18.6241 20.75 16.9167V16.25H6.5Z"
				fill="currentColor"
			/>
			<path
				d="M15.5 7C15.5 7.41421 15.1642 7.75 14.75 7.75H9.25C8.83579 7.75 8.5 7.41421 8.5 7C8.5 6.58579 8.83579 6.25 9.25 6.25H14.75C15.1642 6.25 15.5 6.58579 15.5 7Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
